var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "Distributor in Korea",
      "tabActive": "Dupont Vespel®",
      "bg": "/images/sub/visual/sv3.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('h2', {
    staticClass: "page-tit mb-lg-42"
  }, [_vm._v(" Dupont Vespel® ")])]), _c('sub-bg-image', {
    attrs: {
      "src": "/images/sub/distributor/dupont/dupont-top-img.png",
      "className": "h-lg-280px"
    }
  }, [_c('h3', {
    staticClass: "tit font-weight-semibold mb-8 mb-md-50 mb-lg-100"
  }, [_vm._v(" DUPONT은 약 200년 이상의 "), _c('br'), _vm._v(" 전통을 가진 미국 화학회사 입니다. ")]), _c('p', {
    staticClass: "page-text color-grey-51"
  }, [_vm._v(" Vespel® 부품은 고성능 솔루션을 제공하기 위해서 고온에서의 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" Insulation 역할 및 마모 · 마찰 문제를 해결하기 위한 설계로 제작합니다 ")])])], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "특장점"
    }
  }, [_c('v-row', [_c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/dupont/dupont-icon1.png",
      "iconWidth": "50",
      "num": "01"
    }
  }, [_vm._v(" Vespel® 에서 제작되는 모든 부품의 모양은 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 고객의 요구에 따라 형성됩니다. ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/dupont/dupont-icon2.png",
      "iconWidth": "38",
      "num": "02"
    }
  }, [_vm._v(" 마모 또는 마찰 문제를 극복하고 고온에서도 견딜 수 있으며 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 가장 가혹한 작동 환경에서도 견딜 수 있습니다. ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/dupont/dupont-icon3.png",
      "iconWidth": "50",
      "num": "03"
    }
  }, [_vm._v(" Vespel® 부품을 사용하면 생산의 원활한 가동을 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 유지하고 소모품 자재의 사용 간격을 연장 할 수 있습니다. ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/dupont/dupont-icon4.png",
      "iconWidth": "50",
      "num": "04"
    }
  }, [_vm._v(" Vespel® 부품의 성능은 단순 실용적일 뿐만 아니라 표준 금속, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 세라믹 및 기타 엔지니어링 플라스틱보다 더 뛰어난 경량 부품을 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 만들 수 있습니다. ")])], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('sub-line-layout', {
    staticClass: "mb-40 mb-lg-60",
    attrs: {
      "tit": "Vespel®"
    }
  }, [_c('p', {
    staticClass: "page-text color-grey-51 mb-2 mb-lg-6"
  }, [_vm._v(" Vespel® 은 듀폰상표 3000 종류의 제품군 중 고성능 폴리이미드플라스틱 제품으로 극저온 -196℃ 부터 280℃ "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 수준까지 사용하는 분말 소결 재료입니다. 열에 의한 소성변화가 있는 Polymers (PEEK, PAI) 와는 다르게 유리전이온도 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" (재료가 고체에서 액체상태로 변하는 온도)가 없는 차이가 있으며, Vespel® 플라스틱은 Metals, Ceramics, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" Polymers 재료, 각각에는 없는 특성이 있습니다. ")]), _c('p', {
    staticClass: "page-text color-grey-51 mb-30 mb-lg-52"
  }, [_c('strong', {
    staticClass: "font-weight-bold color-point"
  }, [_vm._v("우주항공, 반도체, 운송장비, 자동차부품, 엔지니어링")]), _vm._v(" 용도로 쓰입니다. ")]), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('table', {
    staticClass: "client-table client-table-lg w-100 border-md-end"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "75%"
    }
  })]), _c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("등급")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Properties ( 특성 )")])])])]), _c('tbody', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SP-1")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 내마모성 ,인장력 우수, 첨가물 ")]), _c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 금형에 의한 생산 가능 ")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v(" · Low outgassing (반도체) ")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SP-3")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 15% 이황화 몰리브덴 포함 ")]), _c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 금형에 의한 생산 불가 ")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v(" · 진공 조건에서 사용 (반도체) ")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SP-21")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 저마모성,저마찰력 (자동차) ")]), _c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 금형에 의한 생산 가능 ")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v(" · 15% 그라파이트 포함 ")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SP-211")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 저 마찰력, 저마모성(SP-21보다우수) ")]), _c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 금형에 의한 생산 가능 ")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v(" · 15% 그라파이트, 10%PTFE 포함 ")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SP-2515")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 최소 열팽창 SP-21의 4배 (자동차) ")]), _c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 금형에 의한 생산 가능 ")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v(" · 10% 그라파이트 포함 ")])])])])])])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('table', {
    staticClass: "client-table client-table--last client-table-lg w-100"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "75%"
    }
  })]), _c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("등급")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Properties ( 특성 )")])])])]), _c('tbody', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SP-202")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 전기전도성이 있는 Vespel®소재 ")]), _c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 금형에 의한 생산 불가 ")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v(" · 정전기 제거 ")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SP-221")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 금형에 의해서만 생산 가능 ")]), _c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 무윤활조건에서 연철(알루미늄, 황동, 동 베어링 등)에 대한 내마모성이 뛰어남 ")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v(" · 15% 그라파이트, 10%PTFE 포함 ")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SCP-5000")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 경도, 내화학성, 치수 안정성,첨가물없음 ")]), _c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · Low outgassing (반도체) ")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v(" · 금형에 의한 생산 불가 ")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SCP-50094")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 내화학성 및 내열산화성 (자동차) ")]), _c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 그라파이트 저 충진 폴리이미드 ")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v(" · 금형에 의한 생산 가능 ")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SCP-5050")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 강철과 유사한 열팽창계수(우주항공) ")]), _c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v(" · 그라파이트 고 충진 폴리이미드 ")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v(" · 금형에 의한 생산 가능 ")])])])])])])])])], 1)], 1), _c('inquiry', {
    attrs: {
      "src": "/images/sub/distributor/dupont/dupont-img1.png",
      "name": "유 동현",
      "tel": "031-765-2268",
      "mail": "davidyoo@ist-co.kr",
      "fax": "031-765-2389",
      "link": "https://www.dupont.com/vespel.html",
      "linkBg": "/images/sub/distributor/dupont/dupont-img2.png"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }